var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "none",
    x: "0px",
    y: "0px",
    width: "320px",
    height: "140px",
    viewBox: "0 0 320 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer0_1_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "none",
    d: " M 67.65 42.15 Q 62.2 39.7 54.65 39.7 L 30.45 39.7 30.45 95.7 43.4 95.7 43.4 80.1 55.3 80.1 66.1 95.7 80.05 95.7 67.45 77.75 Q 73 75.35 75.95 70.85 78.95 66.35 79 60 78.95 53.7 76.05 49.15 73.05 44.6 67.65 42.15 M 62.9 52.8 Q 65.85 55.35 65.85 60 65.85 64.65 62.9 67.2 59.9 69.75 53.95 69.8 L 43.4 69.8 43.4 50.25 53.95 50.25 Q 59.9 50.25 62.9 52.8 M 119.25 52.65 L 119.25 74 Q 119.15 79.9 116.45 82.75 113.75 85.6 109.3 85.6 105.15 85.6 102.9 83.1 100.65 80.55 100.6 75.15 L 100.6 52.65 88.15 52.65 88.15 77.05 Q 88.2 83.65 90.55 87.95 92.85 92.2 97 94.3 101.1 96.35 106.5 96.35 110.55 96.35 113.95 94.9 117.4 93.45 119.85 90.6 L 119.85 95.7 131.7 95.7 131.7 52.65 119.25 52.65 M 188.9 52.65 L 174.05 52.65 155.8 69.9 155.8 36.35 143.35 36.35 143.35 95.7 155.8 95.7 155.8 84.7 161.8 78.85 175.4 95.7 190.5 95.7 171 70.9 188.9 52.65 M 192.95 74.2 Q 192.95 80.65 196 85.6 199 90.6 204.5 93.45 210 96.35 217.5 96.35 223.3 96.35 227.75 94.6 232.25 92.85 235.25 89.4 L 228.6 82.2 Q 226.4 84.3 223.8 85.35 221.2 86.35 217.8 86.35 212.85 86.35 209.65 84.05 206.45 81.75 205.5 77.7 L 238.05 77.7 Q 238.1 76.85 238.2 75.95 238.3 75.1 238.3 74.35 238.2 67.4 235.25 62.4 232.35 57.4 227.3 54.7 222.25 52.05 215.9 52 209.25 52.05 204.1 54.9 198.95 57.7 196 62.7 193 67.7 192.95 74.2 M 223 63.9 Q 225.8 66.3 226.5 70.45 L 205.3 70.45 Q 206.05 66.25 208.85 63.85 211.65 61.5 216 61.45 220.25 61.5 223 63.9 M 281.95 54 Q 277.9 52 272.8 52 268.4 52 264.7 53.45 261.1 54.9 258.55 57.65 L 258.55 52.65 246.65 52.65 246.65 95.7 259.1 95.7 259.1 74.4 Q 259.15 68.45 262 65.6 264.85 62.75 269.45 62.75 273.6 62.75 275.85 65.25 278.1 67.75 278.15 72.95 L 278.15 95.7 290.6 95.7 290.6 71 Q 290.6 64.5 288.25 60.25 285.95 56.05 281.95 54 Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Layer0_0_1_STROKES",
    stroke: "#F50067",
    strokeWidth: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: " M 309.55 70.15 L 309.55 17 160.25 23.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer0_0_2_STROKES",
    stroke: "#2496FF",
    strokeWidth: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: " M 10.95 70.15 L 10.95 123.3 160.2 117.2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_1_STROKES"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_2_STROKES"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_1_FILL"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.61b9472dcb634e824adf8d9ff6fed48c.svg";
export { ForwardRef as ReactComponent };